import React, { Component } from 'react';
import { Panel, PanelGroup, Image, ListGroup } from 'react-bootstrap';

import ControlledPanelGroup from './ControlledPanelGroup';
import ThumbnailGrid from './ThumbnailGrid';
import ThumbnailGridFlex from './ThumbnailGridFlex';
import MobileProjects from './MobileProjects';

import './Projects.css'

export default class Projects extends Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  componentDidMount() {
    document.title = "Chris DiNome - Projects"
  }

  render() {
    const { width } = this.state;
    const { height } = this.state;
    const isMobile = ((width <= 500) || (width < height));

    if (!isMobile) {
      return (
        <div className="my-background">

          {/* <ControlledPanelGroup /> */}
          {/* // <ThumbnailGrid /> */}
          <ThumbnailGridFlex />

        </div>
      )
    }
    else {
      return (
        <MobileProjects />
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Projects.jsx